import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SubSink } from 'subsink';

import { LoginService } from '../services/login-service.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnDestroy {
    private subs = new SubSink();

    username: string;
    password: string;
    badLogin = false;
    resetEmail = false;
    sendEmailError = false;
    noResetUsename = false;
    clearText = false;

    constructor(private loginService: LoginService, private router: Router,private route: ActivatedRoute) {
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    private resetErrors() {
        this.resetEmail = false;
        this.badLogin = false;
        this.noResetUsename = false;
        this.sendEmailError = false;
    }

    onLogin() {
        this.resetErrors();
        // console.log("Login Button Clicked",this.username);
        this.subs.add();
        this.loginService.login(this.username, this.password).subscribe(
            data => {
                sessionStorage.setItem('username', this.username)
                console.log('logged in');
                console.log('Route',this.route);
                console.log('Source: ' , this.route.snapshot.queryParams.sourceDocID);
                let docID = this.route.snapshot.queryParams.sourceDocID;
                if(docID)
                {
                    console.log('Navigating back to source')
                    this.router.navigate(['/Loading'],{queryParams:{sourceDocID:docID}})
                }
                else
                {
                    console.log('Default Nav');
                    this.router.navigate(['/Loading']);
                }
            },
            failed => (this.badLogin = true)
        );
    }

    sendEmail() {
        console.log('Send Reset Email');
        this.resetErrors();
        if (!this.username || this.username.length === 0) {
            this.noResetUsename = true;
        } else {
            this.subs.add(
                this.loginService.resetEmail(this.username).subscribe(
                    data => {
                        this.resetEmail = true;
                    },
                    error => {
                        this.sendEmailError = true;
                    }
                )
            );
        }
    }
}
